import { render, staticRenderFns } from "./TestTypeTitle.vue?vue&type=template&id=558cf760&scoped=true&"
import script from "./TestTypeTitle.vue?vue&type=script&lang=js&"
export * from "./TestTypeTitle.vue?vue&type=script&lang=js&"
import style0 from "./TestTypeTitle.vue?vue&type=style&index=0&id=558cf760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558cf760",
  null
  
)

export default component.exports